<template>
  <el-container class="is-vertical d-block-xs">
    <el-container class="relative column" v-loading="$store.state.libLoading">
      <div v-if="myDemos.length" class="headings no-shrink" style="text-align:center;color:#fff">
        <div style="height: 50px" class="hidden-xs-only"></div>
        <h2>My library</h2>
      </div>

      <div v-if="!myDemos.length && !this.$store.state.libLoading" class="d-flex column flex-grow overflow-hidden">
        <div class="el-main">
          <div  class="no-data-block">
            <div class="headings no-shrink" style="text-align:center;color:#fff">
              <h2 style="margin-top: 0;">My library</h2>
            </div>

            <div class="flex-center">
              <div class="step-block d-flex" @click="createNewTour">
                <div class="step-number">
                  <div><img src="/static/flag.svg" alt=""></div>
                  <div>Step 3</div>
                  <div class="bg-number">3</div>
                </div>
                <div class="step-name">
                  You don't have any tours.<br>
                  Create first one.
                </div>
              </div>
            </div>
            <div class="description">
              On this page tours that you created or used are shown. Go ahead and explore our awesome tours!
            </div>
            <div class="img-cnt flex-center">
              <img src="/static/assign_quiz.png" alt="">
            </div>

          </div>
        </div>
      </div>
      <div class="d-flex justify-center no-shrink" v-if="!$store.state.libLoading" style="margin: 0 0 30px 0;">
        <div v-if='$store.state.user && $store.state.user.role && $store.state.user.role.name === "AssetCreator"'>
          <a class="btn-main shadowfloat"  v-if="$store.state.env === 'development'" :href="$store.state.API_URL + 'edit/new?jwt=' + getJwt()" :class="{'is-active' : ['my-library'].indexOf($route.name) !== -1 }" >
            Create New Tour
          </a>
          <a class="btn-main shadowfloat" @click.prevent="createNewTour" v-else>Create new tour</a>        </div>
        <div v-else class="d-flex">
        <div style="height: 20px" class="hidden-xs-only"></div>
          <a class="btn-main shadowfloat"  v-if="$store.state.env === 'development'" :href="$store.state.API_URL + 'edit/new?jwt=' + getJwt()" :class="{'is-active' : ['my-library'].indexOf($route.name) !== -1 }" >
            Create New Tour
          </a>
          <a class="btn-main shadowfloat" @click.prevent="createNewTour" v-else>Create new tour</a>

          <a class="btn-main shadowfloat" @click.prevent="createNewTourBuild">
            New Tour
            <br/>(Simplified Builder)
          </a>
<!--        <router-link to="/asset-library" class="btn-main shadowfloat">Asset Library</router-link>-->
        </div>

      </div>
      <library-items v-if="myDemos.length" :items="myDemos" v-on:delete-item="deleteTour"></library-items>
      <el-pagination v-if="totalPage!==null" style="margin: 0 auto; padding-bottom: 15px;"
        background
        layout="prev, pager, next"
        @current-change="handlePaginationChange"
        :page-size="pageSize"
        :total="totalPage">
      </el-pagination>

    </el-container>
  </el-container>
</template>

<script>
  import LibraryItems from "../components/library-items.vue"

  export default {
    name: 'MyLibrary',
    components: {
      LibraryItems
    },
    data () {
      return {
        isLoading: false,
        myDemos: [],
        page: 1,
        pageSize: 8,
        totalPage: null,
      }
    },
    mounted: function mounted () {
      if(this.$store.state.user._id) {
        this.getAllData();
      }else{
        setTimeout(() => {
          this.getAllData();
        }, 1000);
      }
    },
    methods: {
      getAllData(){
        if (!this.$store.state.user){
          this.$router.push("/login")
          return;
        }
        this.$store.state.libLoading = true;

        let params = {
          _limit: this.pageSize,
          _start: (this.page-1) * this.pageSize
        };
        try {
          let url = this.$store.state.API_URL+(this.$store.state.user.role.name === 'AssetCreator' ? 'assetlib?author=' :'my-lib?owner=')+this.$store.state.user._id;
          this.axios.get(url, {params: params}).then((res) => {
            this.myDemos = res.data.result;
            this.totalPage = res.data.total;
            this.$store.state.libLoading = false;
          });
        }catch (e) {
          this.$store.state.libLoading = false;
          console.error(e);
        }
      },
      getJwt() {
        return localStorage.getItem("jwt")
      },
      deleteTour(tour) {
        this.myDemos.splice(this.myDemos.indexOf(tour), 1);
        setTimeout(() => {
          this.$redrawVueMasonry();
        }, 100)
      },
      createNewTour(type) {
        let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
        if (type === "asset") {
          window.location.href  = this.$store.state.API_URL + 'edit_asset/new' + jwt;
        } else {
          window.location.href  = this.$store.state.API_URL + 'edit/new' + jwt;

        }
        // this.axios.get(this.$store.state.API_URL + 'createNewDemo')
        //   .then((res) => {
        //     let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
        //     window.location.href  = this.$store.state.API_URL + 'edit/' + res.data.id + jwt;
        //   });
      },
      createNewTourBuild() {
        let jwt = this.$store.state.env === "development" ? ("?jwt=" + localStorage.getItem("jwt")) : "";
        window.location.href  = this.$store.state.API_URL + 'build/new' + jwt;
      },
      handlePaginationChange(val) {
        this.page = val;
        this.getAllData();
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/MyLibrary.vue